export default __webpack_public_path__ + "static/media/Shades_of_Spring.0ecad16b.mp3";